import React, {Component} from 'react'
import ReactTable from 'react-table'
import axios from 'axios'
import PopUp from '../UI_Elements/Forms/PopUp';
import 'react-confirm-alert/src/react-confirm-alert.css'
import Config from '../../config'
import {isHarbour,isAdmin, isAsimilatedByAdmin, notification} from '../../helpers'
import FileDownload from 'js-file-download';
import moment from 'moment';

class ConfirmTable extends Component {
    constructor(props) {
        super(props)

        this.state = {
            data: [],
            knapp: false,
            selected: [],
            selectedNew:[],
            wheelChangerId: '',
            selectAll: false,
            showConfirmSendBack: false,
            showConfirmForceTransit: false
        }

        this.printExcel = this.printExcel.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.confirmOrders = this.confirmOrders.bind(this);
        this.handleCheckAll = this.handleCheckAll.bind(this);
        this.handleForceTransit = this.handleForceTransit.bind(this);
        this.handleSendBack = this.handleSendBack.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({data: nextProps.ordersToConfirm})
    }

    componentDidMount() {
        this.setState({data: this.props.ordersToConfirm})
    }

    getColumns(){
        let columns = [
            {
                Header: props => {
                    return (
                        <div className='select-all-wrapper'>
                            {
                                isHarbour() &&
                                <input
                                    type='checkbox'
                                    onChange={this.handleCheckAll}
                                    checked={this.state.selectAll}
                                />
                            }
                            Regnr
                        </div>
                    )
                },
                accessor: "regNo",
                width: 100,
                resizable: false
            },
            {
                Header: "Ordernr",
                accessor: "orderNr",
                width: 100
            },
            {
                Header: "Bilmodell",
                accessor: "carModel"
            },
            {
                Header: "Hjultyp",
                accessor: "wheeltype",
            }
        ];
        if (!this.props.hidePreferedDate) {
            columns.push({
                Header: "Önskat leveransdatum",
                accessor: "orderdate",
            })
        }
        if (this.props.showPickedDate) {
            columns.push({
                Header: "Plockad",
                accessor: "pickedDate"
            })
        }
        columns.push({
            Header: "Kommentar",
            accessor: "comment"
        })
        columns.push({
            Header: "Sändningsnummer",
            accessor: "trackingId",
            Cell: (row) => {
                if (row.value) {
                    const trackingURL = `https://www.dbschenker.com/app/tracking-public/?refNumber=${row.value}`;
                    return (
                        <a href={trackingURL} target="_blank" rel="noopener noreferrer">
                            {row.value}
                        </a>
                    );
                }
                return '-';
            }
        });
        return columns;
    }

    getActionType(){

        if (this.state.showConfirmSendBack){
            return "send_back";
        }

        if (this.state.showConfirmForceTransit){
            return "force_transit";
        }

        return "";
    }

    getConfirmText(){
        let text = null;

        if ((this.state.selected.length % 3) !== 0){
            text ="Beställning är inte jämt delbart med 3 vilket påverkar transportkostnaden (Det får plats 3 hjul-set per pall). Är du säker på att du vill genomföra beställningen eller kan du lägga till uppsättning/uppsättningar för att optimera transportkostnaden?";
        }

        return text;
    }

    getConfirmTitle(){
        let warning ="";
        if ((this.state.selected.length % 3) !== 0){
            warning = " (Ej delbart med 3) ";
        }
        switch(this.getActionType()){
            case "send_back":
                return "Sänd tillbaka order"+warning+"?";
            case "force_transit":
                return "Force transit?";
            default:
                return "Unknow action?";
        }
    }

    handleSubmit(e) {

        if (this.state.selected.length > 0) {
            this.confirmOrders();
        }
    }

    handleCheckAll() {
        if (!this.state.selectAll) {
            this.setState({selectAll: true})
            this.state.data.forEach((wheel, index) => {
                this.state.selected.push(index)
            })
        } else {
            this.setState({
                selected: [],
                selectedNew:[],
                selectAll: false
            })
        }
    }

    handleSendBack(e){
        this.setState({
            showConfirmDeliver:false,
            showConfirmSendBack:true,
            showConfirmForceTransit:false
        })
    }

    handleForceTransit(e){
        this.setState({
            showConfirmDeliver:false,
            showConfirmSendBack:false,
            showConfirmForceTransit:true
        })
    }

    onPopupActionCancel(){
        this.setState({
            showConfirmDeliver:false,
            showConfirmSendBack:false,
            showConfirmForceTransit:false
        })

    }

    onPopupActionAccept(e){
        switch(this.getActionType()){
            case "send_back":
                this.sendBack();
                break;
            case "force_transit":
                this.forceTransit();
                break;
            default:
                notification("Unknow action");
                break;
        }
    }

    confirmOrders() {
        const data = {
            orderIds: [],
            wheelOrderIds: [],
            wheelChangerId: Config.api.getWheelChangerId()
        }

        this.state.data.forEach((order, i) => {
            if (this.state.selected.includes(i)) {
                data.orderIds.push(order.orderId)
                data.wheelOrderIds.push(order.wheelOrderId)
            }
        })

        axios.post(Config.api.getDomain() + 'order/confirm', data, Config.api.getConfig())
            .then(response => {
                this.props.updateOrders()
                this.setState({
                    selected: [],
                    selectAll: false,
                })
            })
            .catch(error => {
                let message = error.response.data.message;
                notification('Kunde inte mottagningsbekräfta: ' + message)
            })
    }

    sendBack(){
        let params = {
            orderIds: [],
            wheelOrderIds: [],
            wheelChangerId: parseInt(Config.api.getWheelChangerId(), 10)
        }

        this.state.data.forEach((order, i) => {
            if (this.state.selected.includes(i)) {
                params.orderIds.push(order.orderId)
                params.wheelOrderIds.push(order.wheelOrderId)
            }
        })

        axios.post(Config.api.getDomain() + 'order/sendBackOrder', params, {
            'headers': {
                'Authorization': 'Bearer ' + Config.api.getTokenOriginal(),
                'pragma': 'no-cache'
            },
            'params':params
        })
            .then(response => {
                this.props.updateOrders();
                this.setState({
                    selected: [],
                    selectedNew: [],
                    selectAll: false,
                    showConfirmSendBack: false,
                    showConfirmForceTransit:false
                })
            })
            .catch(error => {
                let message = error.response.data.message;
                notification('Kunde inte återställa order: ' + message)
                this.setState({
                    showConfirmSendBack: false,
                    showConfirmForceTransit:false
                })
            })

    }

    forceTransit(){
        console.log("maybe will need to implement this later");
    }

    printExcel(e) {
        e.preventDefault();
         const reportTypeName = 'Bestallning';
         const reportType = 9;
         const filename = reportTypeName + '_' + moment().format('YYYY_MM_DD') + '.xlsx'
  
         let data = {
             'reportType': reportType,
             'wheelChangerId': Config.api.getWheelChangerId(),
             "orderStatuses": [
                "3", "5"
              ]
         }
         
         axios.post(Config.api.getDomain() + 'report/reportExcelExport', data, {
             headers: Config.api.getConfig().headers,
             responseType: 'blob',
         })
         .then(response => {
             FileDownload(response.data, filename)
         })
         .catch(error => {
             console.log(error)
         })
     }

    render() {
        const columns = this.getColumns();
        const {showConfirmForceTransit,showConfirmSendBack} = this.state;

        return (         
            <div className="confirm-orders">
                <h2>{this.props.title}</h2>
                
                <div className="print-excel-wrapper">
                    <button
                        type="button"
                        className="btn yellow print-excel"
                        onClick={ this.printExcel }
                        disabled={ this.state.data.length > 0 ? false : true }
                    >
                        Hämta Excel-fil
                    </button>
                </div>

                <ReactTable
                    data={this.state.data}
                    columns={columns}
                    minRows="0"
                    pageSize="200"
                    className="need-confirm-ordertable"
                    showPagination={false}
                    noDataText='Hittade inga däck att mottagningsbekräfta'
                    getTrProps={(state, rowInfo, column) => {

                        let selectedClass="";
                        if (this.state.selected.indexOf(rowInfo.index) !== -1){
                            selectedClass="selected";
                        } else {
                            if (parseInt(rowInfo.original.status, 10) === 5){
                                selectedClass = "new-order";
                            }
                        }

                        return {
                            onClick: (e) => {
                                if (!isAdmin() && !isAsimilatedByAdmin()){
                                    if (parseInt(rowInfo.original.status, 10) === 5) {
                                        //To prevent the notification when clicking on the trackingURL.
                                        if(e.target.getAttribute('href') != null) {
                                            if(!e.target.getAttribute('href').includes("https://www.logistics.dhl/se-sv/home/tracking/tracking-freight.html")){
                                                notification("Kan inte ändra status för det här objektet än. Väntar på godkännande.");
                                            }
                                        }
                                        else{
                                            notification("Kan inte ändra status för det här objektet än. Väntar på godkännande.");
                                        }
                                        return false;
                                    }
                                }

                                let selected = this.state.selected;
                                let selectedNew = this.state.selectedNew;

                                let indexOfItem_selected = selected.indexOf(rowInfo.index);
                                let indexOfItem_selectedNew = selectedNew.indexOf(rowInfo.index);
                                var isInArray = (indexOfItem_selected!==-1);

                                this.setState({selectAll: false});

                                if (!isInArray) {
                                    selected.push(rowInfo.index);
                                    if (parseInt(rowInfo.original.status, 10) === 5) {
                                        selectedNew.push(rowInfo.index);
                                    }
                                    this.setState({
                                        selected: selected,
                                        selectedNew:selectedNew
                                    })
                                } else {
                                    if (indexOfItem_selected>-1){
                                        selected.splice(indexOfItem_selected, 1);
                                    }
                                    if (indexOfItem_selectedNew>-1){
                                        selectedNew.splice(indexOfItem_selectedNew, 1);
                                    }
                                    this.setState({
                                        selected: selected,
                                        selectedNew: selectedNew
                                    })
                                }
                            },
                            className: selectedClass
                        }
                    }
                    }
                />

                <input
                    type={"submit"}
                    onClick={this.handleSubmit}
                    className={this.state.selected.length === 0 ? "btn yellow confirmorders disabled" : "btn yellow confirmorders"}
                    name="confirmorders"
                    disabled={this.state.selected.length === 0}
                    value={"Mottagningsbekräfta"+ (this.state.selected.length>0? " ("+this.state.selected.length+") ":"")}
                />


                {((isAdmin() || isAsimilatedByAdmin()) && this.props.showSendBackBtn) &&
                <input
                    type={"submit"}
                    onClick={(e)=>this.handleSendBack(e)}
                    className={this.state.selected.length === 0 ? "btn yellow confirm-send-back disabled" : "btn yellow confirm-send-back"}
                    name="sendBack"
                    disabled={this.state.selected.length === 0}
                    value={"Sänd tillbaka order" +(this.state.selected.length>0? " ("+this.state.selected.length+") ":"")}
                />
                }


                {/*{isAdmin() &&*/}
                {/*<input*/}
                    {/*type={"submit"}*/}
                    {/*onClick={(e)=>this.handleForceTransit(e)}*/}
                    {/*className={this.state.selectedNew.length === 0 ? "btn yellow confirm-force-transit disabled" : "btn yellow confirm-force-transit"}*/}
                    {/*name="forceTransit"*/}
                    {/*disabled={this.state.selectedNew.length === 0}*/}
                    {/*value={"Force Transit"+(this.state.selectedNew.length>0? " ("+this.state.selectedNew.length+") ":"")}*/}
                {/*/>*/}
                {/*}*/}


                {(showConfirmSendBack || showConfirmForceTransit) &&
                <PopUp
                    onCancel={(event) => this.onPopupActionCancel(event)}
                    onAccept={(event) => this.onPopupActionAccept(event)}
                    title={this.getConfirmTitle()}
                >
                    <p>
                        {this.getConfirmText()}
                    </p>
                </PopUp>
                }

            </div>
        )
    }
}

// const mapStateToProps = (state) => {
//   return {
//       refresh: state.refresh
//   };
// };

// const mapDispatchToProps = (dispatch) => {
//   return {
//       setFalse: (key) => dispatch(setFalse(key)),
//   };
// };

export default ConfirmTable


// WEBPACK FOOTER //
// ./src/components/Orders/ConfirmTable.js